/* GOLDSQUARE - reduced motion

   Autoplay cannot be prevented from CSS, so anyone with
   prefers-reduced-motion enabled is left with looping footage they have
   explicitly asked not to see. This pauses decorative section video and
   leaves the poster frame in place.

   It also listens for changes, because the OS setting can be toggled
   while the page is open.
*/

(function () {
  'use strict';
  if (!window.matchMedia) return;

  var mq = window.matchMedia('(prefers-reduced-motion: reduce)');

  function apply() {
    var videos = document.querySelectorAll('[data-motion-pause] video');
    for (var i = 0; i < videos.length; i++) {
      var v = videos[i];
      if (mq.matches) {
        v.removeAttribute('autoplay');
        v.autoplay = false;
        v.pause();
      } else if (v.paused) {
        // Play can reject if the browser blocks it; that is fine, the
        // poster frame stays and nothing is broken.
        var p = v.play();
        if (p && p.catch) { p.catch(function () {}); }
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }

  if (mq.addEventListener) { mq.addEventListener('change', apply); }
  else if (mq.addListener) { mq.addListener(apply); }

  document.addEventListener('shopify:section:load', apply);
})();
